<div class="container">

  <common-headboard>
  </common-headboard>
  <banner-dhl>    
  </banner-dhl>
</div>

<router-outlet></router-outlet>

<common-foot>
</common-foot>

